import { useMemo } from 'react'

import { sortArrayBy } from '@domain-group/javascript-utils'
import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useSelector from '@hooks/useSelector'
import { useParams } from 'react-router-dom'

const watchEntityKeys = ['agencies']

const setSelectedAgencyId = (agencyId: number | string) => {
  const pathName = window.location.hash
  const match = pathName.match(/agencies\/([0-9]+|all)/)
  const updatedUrl = match ? pathName.replace(`${match[1]}`, `${agencyId}`) : pathName

  window.location.hash = updatedUrl
}

function useAgencySelector() {
  const { agencyId: selectedAgencyId } = useParams()

  const {
    updatedEntities: { agencies: agenciesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { agency } = useCurrentUser()

  const { agencies, brands } = useSelector(reduxState => reduxState.entities)

  const sortedAgencies = useMemo(() => {
    const array = Object.values(agencies)
    const sorted = sortArrayBy(array, 'asc', 'title')
    return sorted
  }, [agenciesUpdatedAt])

  const hasMultipleAgencies = sortedAgencies.length > 1
  // @ts-expect-error TS2538
  const selectedAgency = agencies[selectedAgencyId] || agency

  return {
    agencies,
    agencyIdParam: selectedAgencyId,
    brand: brands[selectedAgency?.brand_id] || {},
    callbacks: {
      selectAgencyId: (agencyId: number | string) => setSelectedAgencyId(agencyId),
    },
    hasMultipleAgencies,
    selectedAgency,
    selectedAgencyId: selectedAgencyId === 'all' ? undefined : Number(selectedAgencyId) || agency.id,
    sortedAgencies,
  }
}

export default useAgencySelector
